<template>
    
    <div class="login-wrap" >
        <div class="ms-login">
            <div class="ms-title">胖布丁后台管理系统</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="param.username" placeholder="账号">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="密码"
                        v-model="param.password"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>

                <div class="login-btn" style="margin-top: 5px">
                    <el-button type="primary" :disabled="loading" @click="submitForm()" :loading="loading">登 录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { userAdminLogin } from '@api/dashboard';
import { remoteServiceUrl } from '@api/svnAPI';
import { localStg } from '@/utils/storage/local';
import bus from '@/components/common/bus';
import { EnumLocalStore } from '@/constant/enums';

export default {
    data: function() {
        return {
            param: {
                username: '',
                password: '',
            },
            rules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
            loading: false
        };
    },
    methods: {
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    this.loading = true
                    let params = {"account": this.param.username, "password": this.param.password};
                    userAdminLogin(params).then(loginRes => {
                        if (loginRes.code !== 200) {
                            this.loading = false
                            return
                        }
                        let data = loginRes.data
                        const username = this.param.username
                        localStg.set(EnumLocalStore.jwtTokenName, data.token);
                        localStg.set('cotton_username', this.param.username);
                        localStg.set('cotton_msNickname', data.data.nickName)
                        localStg.set('cotton_userid', data.data.userId)
                        localStg.set('cotton_pwdflag', false)
                        localStg.set('administrator', data.data.administrator)
                        localStg.set("roleList", data.data.roleList)
                        bus.$emit('leftMenu', data.data.roleList)
                        // 原系统
                        // localStorage.setItem("token", data.token)
                        // 保存 账号丶昵称丶用户ID
                        localStorage.setItem('ms_username', this.param.username)
                        localStorage.setItem('ms_nickname', data.data.nickName)
                        localStorage.setItem('userId', data.data.userId)
                        localStorage.setItem('pwdFlag', false)
    
                        // SVN 服务地址
                        let serviceUrlStr = localStorage.getItem(username + 'ServiceUrl')
                        // 如果为空, 赋默认值, 默认为 远程地址
                        if (serviceUrlStr == null) localStorage.setItem(username + 'ServiceUrl', remoteServiceUrl)
                        this.$message.success('登陆成功')
                        this.$router.push('/dashboard')
                        this.loading = false
                    })
                }
            })
        },

        //数据去重
        unique(arr){
            //Set数据结构，它类似于数组，其成员的值都是唯一的
            return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
        },

        //前往注册页
        goRegister () {
            this.$router.push('/register');
        },
    },
    created() {
        if (localStg.get("jwtToken")) {
            this.$router.push('/dashboard')
        }
    }
};
</script>


<style scoped>

/* Login页，登录框 */
.el-form-item__content .el-input-group {
    border-radius: 15px;
}

.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url('../../assets/img/background.jpg');
    background-size: cover;
    
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    height: max-content;
    margin: -190px 0 0 -175px;
    border-radius: 15px;
    padding-bottom: 1rem;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    
    padding: 30px 30px 1px 30px;
}

.login-btn {
    text-align: center;
}
.login-btn button  {
    border-radius: 6px;
    width: 100%;
    height: 36px;
    margin-bottom: 8px;
    /* 添加过渡时间 1s */
    transition: 0.6s;
}

.register-btn button{
    text-align: center;
    font-size: 15px;
    text-decoration:underline;
    background-color:transparent;
    border: none;
    border-radius: 5px;
    margin-left: 208px;
    margin-bottom: -5px;
    /* 添加过渡时间 1s */
    transition: 0.6s;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>
